import {
  Package,
  Globe,
  ShoppingCart,
  Wallet,
  Clock,
  Phone,
} from "lucide-react";
import { Facebook } from "react-feather";

const Footer = () => {
  return (
    <footer id="contact" className="bg-[#122d67] text-navy-foreground py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          {/* Services */}
          <div className="animate-fade-up">
            <h3 className="text-lg font-bold text-accent mb-4">
              МАНАЙ ҮЙЛЧИЛГЭЭ
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <Globe className="w-5 h-5 text-accent" />
                <span>БНХАУ-ын бүх хот мужуудаас шуурхай тээвэр</span>
              </li>
              <li className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <ShoppingCart className="w-5 h-5 text-accent" />
                <span>Хятадын онлайн шопуудаас захиалга хийх сургалт</span>
              </li>
              <li className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary-foreground transition-colors">
                <Wallet className="w-5 h-5 text-accent" />
                <span>Alipay, Wechat юаны шилжүүлэг</span>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div className="animate-fade-up delay-100">
            <h3 className="text-lg font-bold text-accent mb-4">
              АЖИЛЛАХ ЦАГИЙН ХУВААРЬ
            </h3>
            <div className="flex items-center gap-3 text-primary-foreground/80">
              <Clock className="w-5 h-5 text-accent" />
              <span>
                Мягмар-Бямба 11:00-19:00 цаг<br />
                Ням, Даваа: Амрана
              </span>
            </div>
          </div>

          {/* Contact */}
          <div className="animate-fade-up delay-200">
            <h3 className="text-lg font-bold text-accent mb-4">ХОЛБОО БАРИХ</h3>
            <a
              href="tel:72828713"
              className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary transition-colors"
            >
              <Phone className="w-5 h-5 text-accent" />
              <span className="text-lg">72828713</span>
            </a>
            <a
              href="https://www.facebook.com/khulegcargomn"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-primary-foreground/80 hover:text-primary transition-colors"
            >
              <Facebook className="w-5 h-5 text-accent" />
              <span className="text-lg ">Facebook пэйжид нэгдэх</span>
            </a>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary-foreground rounded-full flex items-center justify-center">
                <Package className="w-5 h-5 text-primary" />
              </div>
              <span className="font-bold">Khuleg Cargo</span>
            </div>
            <p className="text-sm text-primary-foreground/60">
              ©2025 ЗОХИОГЧИЙН ЭРХ ХУУЛИАР ХАМГААЛАГДСАН
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
